import React, { forwardRef } from "react";
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";

const DoInputField = forwardRef((props, ref) => {
  const id = props.id || props.name;
  const label = props.label || '';
  const name = props.name;
  const type = props.type || 'text';
  const field = props.field;
  const placeholder = props.placeholder;
  const style = props.style || null;
  const disable = props.disable;

  const isCurrency = props.isCurrency || false;
  const currency = props.currency || "INR";
  const locale = props.locale || "en-IN";

  const markRequired = () => (
    <FontAwesomeIcon
      color="red"
      icon={faAsterisk}
      style={{ width: "7px", marginBottom: "5px", marginLeft: "2px" }}
    />
  );

  return (
    <div className="flex flex-column">
      <div className="flex align-center">
        <label htmlFor={id} className="text-capitalize">
          {label}
        </label>
        {props.markReq && markRequired()}
      </div>

      {isCurrency ? (
        <InputNumber
          ref={ref}
          field={field}
          inputId={id}
          name={name}
          value={field.value ?? null}
          onValueChange={(e) => field.onChange(e.value)}
          mode="currency"
          currency={currency}
          locale={locale}
          placeholder={placeholder}
          disabled={disable}
          style={style}
          minFractionDigits={2}
          maxFractionDigits={2}
          useGrouping={true}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
        />
      ) : (
        <InputText
          ref={ref}
          type={type}
          field={field}
          value={field?.value ?? ""}
          id={id}
          name={name}
          placeholder={placeholder}
          disabled={disable}
          style={style}
          onChange={(e) => field.onChange(e.target.value)}
          onKeyDown={(e) => {
            if (type === "number" && (e.key === "e" || e.key === "E")) {
              e.preventDefault();
            }
          }}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
        />
      )}

      <small className="text-danger">
        {props.fieldState?.invalid
          ? props.errors?.[props.name]?.message
          : ""}
      </small>
    </div>
  );
});

export default DoInputField;